import { useEffect, useRef } from 'react';

/**
 * Behaviour every full-screen sheet / dialog shares (redesign step 8): Escape closes it and the
 * page behind doesn't scroll while it is open. Nested sheets are fine — the body scroll is only
 * given back when the last one closes.
 */
let openSheets = 0;

export function useSheet(open: boolean, onClose?: () => void) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!open) return;
    openSheets += 1;
    const body = document.body;
    if (openSheets === 1) body.dataset.sheetOverflow = body.style.overflow;
    body.style.overflow = 'hidden';
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && onCloseRef.current) onCloseRef.current();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      openSheets = Math.max(0, openSheets - 1);
      if (openSheets === 0) {
        body.style.overflow = body.dataset.sheetOverflow || '';
        delete body.dataset.sheetOverflow;
      }
    };
  }, [open]);
}
